import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const EngagementSection = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const teamConnections = [
    {
      id: 1,
      name: "Jasmeet Singh",
      role: "Founder & Creative Director",
      expertise: "Digital Strategy, UI/UX Design",
      linkedin: "https://linkedin.com/in/Jasmeet-singh",
      image: "https://cdn-icons-png.flaticon.com/512/9193/9193919.png",
      // image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
      available: true
    },
    // {
    //   id: 2,
    //   name: "Mehar Kaur",
    //   role: "Lead Developer",
    //   expertise: "Full-Stack Development, Digital Marketing Specialist",
    //   linkedin: "https://linkedin.com/in/Mehar-Kaur",
    //   image: "https://cdn-icons-png.flaticon.com/512/6997/6997662.png",
    //   available: true
    // },
  ];

  const engagementOptions = [
    {
      id: 1,
      title: "Free Consultation",
      description: "30-minute strategy session to discuss your digital transformation needs",
      duration: "30 minutes",
      price: "Free",
      features: [
        "Digital audit of current presence",
        "Strategic recommendations",
        "Technology roadmap discussion",
        "No-obligation proposal"
      ],
      icon: "MessageCircle",
      color: "primary",
      popular: false
    },
    {
      id: 2,
      title: "Strategy Workshop",
      description: "Comprehensive 2-hour deep-dive into your business goals and digital strategy",
      duration: "2 hours",
      price: "₹1999",
      features: [
        "Detailed competitor analysis",
        "User journey mapping",
        "Technology stack recommendations",
        "Implementation timeline",
        "ROI projections"
      ],
      icon: "Target",
      color: "accent",
      popular: true
    },
    {
      id: 3,
      title: "Technical Review",
      description: "In-depth analysis of your current technical infrastructure and optimization opportunities",
      duration: "1 hour",
      price: "₹1000",
      features: [
        "Performance audit",
        "Security assessment",
        "Scalability review",
        "Optimization recommendations"
      ],
      icon: "Settings",
      color: "success",
      popular: false
    }
  ];

  const insightTopics = [
    "Digital Transformation Trends",
    "E-commerce Optimization",
    "Mobile-First Design",
    "AI in Web Development",
    "Conversion Rate Optimization",
    "Brand Identity in Digital Age"
  ];

  const handleNewsletterSubmit = (e) => {
    e?.preventDefault();
    if (newsletterEmail) {
      setIsSubscribed(true);
      setNewsletterEmail('');
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-12 h-12 bg-conversion rounded-lg flex items-center justify-center">
              <Icon name="Handshake" size={24} className="text-white" />
            </div>
            <span className="text-conversion font-semibold text-lg">Let's Connect</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Start Your Digital Journey
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Ready to transform your digital presence? Connect with our team, book a consultation, or stay updated with industry insights.
          </p>
        </div>

        {/* Team Connections */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-foreground mb-4">Connect with Our Team</h3>
            <p className="text-lg text-muted-foreground">
              Get direct access to our experts and start building meaningful professional relationships
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {teamConnections?.map((member) => (
              <div key={member?.id} className="bg-white rounded-2xl p-6 brand-shadow brand-transition brand-hover-lift">
                <div className="text-center mb-4">
                  <div className="relative inline-block mb-3">
                    <img
                      src={member?.image}
                      alt={`${member?.name} - ${member?.role}`}
                      className="w-16 h-16 rounded-full object-cover mx-auto"
                    />
                    <div className={`absolute -bottom-1 -right-1 w-5 h-5 rounded-full border-2 border-white ${
                      member?.available ? 'bg-success' : 'bg-muted-foreground'
                    }`}></div>
                  </div>
                  <h4 className="font-bold text-foreground mb-1">{member?.name}</h4>
                  <p className="text-sm text-accent font-semibold mb-2">{member?.role}</p>
                  <p className="text-xs text-muted-foreground mb-4">{member?.expertise}</p>
                </div>

                {/* <a
                  href={member?.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-full flex items-center justify-center space-x-2 px-4 py-2 rounded-lg brand-transition ${
                    member?.available
                      ? 'bg-primary text-white hover:bg-primary/90' :'bg-muted text-muted-foreground cursor-not-allowed'
                  }`}
                >
                  <Icon name="Linkedin" size={16} />
                  <span className="text-sm font-medium">
                    {member?.available ? 'Connect' : 'Unavailable'}
                  </span>
                </a> */}
              </div>
            ))}
          </div>
        </div>

        {/* Consultation Options */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-foreground mb-4">Book Your Consultation</h3>
            <p className="text-lg text-muted-foreground">
              Choose the engagement level that best fits your needs and timeline
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {engagementOptions?.map((option) => (
              <div key={option?.id} className={`relative bg-white rounded-2xl p-8 brand-shadow brand-transition brand-hover-lift ${
                option?.popular ? 'ring-2 ring-accent' : ''
              }`}>
                {option?.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-accent text-white px-4 py-1 rounded-full text-sm font-semibold">
                      Most Popular
                    </span>
                  </div>
                )}

                <div className="text-center mb-6">
                  <div className={`w-16 h-16 bg-${option?.color}/10 rounded-full flex items-center justify-center mx-auto mb-4`}>
                    <Icon name={option?.icon} size={32} className={`text-${option?.color}`} />
                  </div>
                  <h4 className="text-xl font-bold text-foreground mb-2">{option?.title}</h4>
                  <p className="text-muted-foreground mb-4">{option?.description}</p>
                  <div className="flex items-center justify-center space-x-2 mb-4">
                    <span className="text-3xl font-bold text-foreground">{option?.price}</span>
                    <span className="text-muted-foreground">/ {option?.duration}</span>
                  </div>
                </div>

                <div className="space-y-3 mb-8">
                  {option?.features?.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <Icon name="CheckCircle" size={16} className="text-success" />
                      <span className="text-sm text-muted-foreground">{feature}</span>
                    </div>
                  ))}
                </div>

                <Button
                  variant={option?.popular ? "default" : "outline"}
                  fullWidth
                  className={option?.popular ? "bg-accent hover:bg-accent/90" : ""}
                  iconName="Calendar"
                  iconPosition="left"
                >
                  Book {option?.title}
                </Button>
              </div>
            ))}
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="mb-16">
          <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-white">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-4">Stay Ahead with Industry Insights</h3>
                <p className="text-white/90 mb-6">
                  Get weekly insights, case studies, and trend analysis delivered to your inbox. Join 2,500+ digital professionals who trust our expertise.
                </p>
                
                <div className="space-y-2 mb-6">
                  <h4 className="font-semibold mb-3">What you'll receive:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {insightTopics?.map((topic, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <Icon name="CheckCircle" size={14} className="text-accent" />
                        <span className="text-sm text-white/80">{topic}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <form onSubmit={handleNewsletterSubmit} className="space-y-4">
                  <Input
                    type="email"
                    placeholder="Enter your email address"
                    value={newsletterEmail}
                    onChange={(e) => setNewsletterEmail(e?.target?.value)}
                    className="bg-white/20 border-white/30 text-white placeholder-white/70"
                    required
                  />
                  
                  <Button
                    type="submit"
                    fullWidth
                    variant="default"
                    className="bg-accent hover:bg-accent/90 text-white"
                    iconName={isSubscribed ? "CheckCircle" : "Mail"}
                    iconPosition="left"
                    disabled={isSubscribed}
                  >
                    {isSubscribed ? "Subscribed!" : "Subscribe to Insights"}
                  </Button>
                </form>

                <p className="text-xs text-white/70 mt-3 text-center">
                  No spam, unsubscribe anytime. Read our privacy policy.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-6 brand-shadow text-center">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Icon name="Phone" size={24} className="text-primary" />
            </div>
            <h4 className="font-bold text-foreground mb-2">Call Us Directly</h4>
            <p className="text-muted-foreground mb-4">Speak with our team immediately</p>
            <a
              href="tel:+91-7982843491"
              className="text-primary font-semibold hover:text-primary/80 brand-transition"
            >
              +91-7982843491
            </a>
          </div>

          <div className="bg-white rounded-2xl p-6 brand-shadow text-center">
            <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Icon name="MessageSquare" size={24} className="text-accent" />
            </div>
            <h4 className="font-bold text-foreground mb-2">Live Chat</h4>
            <p className="text-muted-foreground mb-4">Get instant answers to your questions</p>
            <Button variant="outline" size="sm">
              Start Chat
            </Button>
          </div>

          <div className="bg-white rounded-2xl p-6 brand-shadow text-center">
            <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Icon name="MapPin" size={24} className="text-success" />
            </div>
            <h4 className="font-bold text-foreground mb-2">Visit Our Office</h4>
            <p className="text-muted-foreground mb-4">Meet us in person in Delhi</p>
            <Button variant="outline" size="sm">
              Get Directions
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EngagementSection;